export default __webpack_public_path__ + "static/media/nl-bg.707ab5dd.webp";